import generalSettingsImg from 'assets/images/settings.png';
import securitySettingsImg from 'assets/images/security_settings.png';
import advancedSettingsImg from 'assets/images/advanced_settings.png';

const settings = {
    id: 'settings',
    title: 'Settings',
    type: 'group',
    children: [
        {
            id: 'settings-general',
            title: 'General',
            type: 'item',
            icon: generalSettingsImg,
            url: '/settings/general',
            breadcrumbs: false

            // children: [
            //     {
            //         id: 'devices',
            //         title: 'Settings',
            //         type: 'item',
            //         url: '/general-settings/settings',
            //         breadcrumbs: false
            //     },
            //     {
            //         id: 'settings-equivalents',
            //         title: 'Equivalents',
            //         type: 'item',
            //         url: '/general-settings/equivalents',
            //         breadcrumbs: false
            //     },
            //     {
            //         id: 'settings-dashboard',
            //         title: 'Dashboard',
            //         type: 'item',
            //         url: '/general-settings/dashboard',
            //         breadcrumbs: false
            //     }
            // ]
        },
        {
            id: 'settings-security',
            title: 'Security',
            type: 'item',
            icon: securitySettingsImg,
            url: '/settings/security',
            breadcrumbs: false

            // children: [
            //     {
            //         id: 'settings-app-whitelist',
            //         title: 'App Whitelist',
            //         type: 'item',
            //         url: '/security-settings/app-whitelist',
            //         breadcrumbs: false
            //     },
            //     {
            //         id: 'settings-password',
            //         title: 'Password Rules',
            //         type: 'item',
            //         url: '/security-settings/password-rules',
            //         breadcrumbs: false
            //     },
            //     {
            //         id: 'settings-logging',
            //         title: 'Logging Level',
            //         type: 'item',
            //         url: '/security-settings/logging-level',
            //         breadcrumbs: false
            //     },
            //     {
            //         id: 'settings-upgrade',
            //         title: 'Upgrade',
            //         type: 'item',
            //         url: '/security-settings/upgrade',
            //         breadcrumbs: false
            //     }
            // ]
        },
        {
            id: 'settings-advanced',
            title: 'Advanced',
            type: 'item',
            url: '/settings/advanced',
            icon: advancedSettingsImg,
            breadcrumbs: false
            // children: [
            //     {
            //         id: 'settings-scripting',
            //         title: 'Scripting',
            //         type: 'item',
            //         url: '/advanced-settings/scripting',
            //         breadcrumbs: false
            //     },
            //     {
            //         id: 'settings-demand-reduction',
            //         title: 'Demand Reduction',
            //         type: 'item',
            //         url: '/advanced-settings/demand-reduction',
            //         breadcrumbs: false
            //     },
            //     {
            //         id: 'settings-iupdate',
            //         title: 'iUpdate',
            //         type: 'item',
            //         url: '/advanced-settings/iupdate',
            //         breadcrumbs: false
            //     }
            // ]
        }
    ]
};

export default settings;
